import {
  pageUrlAliases,
  pageUrls,
  resolveFloaterPageKey,
  sortedPageUrlKeys,
} from 'pages/Admin/AdminTools/Configuration/FloaterTabs/constants'

/** All screens shown in Global Settings → Contact Info / PTR “Show on Screens”. */
export const contactInfoScreenOptions = (): Record<string, { title: string; url: string }> => {
  const options: Record<string, { title: string; url: string }> = {}
  sortedPageUrlKeys.forEach((key) => {
    options[key] = { title: pageUrls[key].title, url: pageUrls[key].url }
  })
  return options
}

/** Default: only Loan Overview (current behavior). */
export const defaultPullThroughRatioScreens = (): Record<string, boolean> => {
  const screens: Record<string, boolean> = {}
  Object.keys(contactInfoScreenOptions()).forEach((key) => {
    screens[key] = key === 'loanOverview'
  })
  return screens
}

export const loanProcessMenuToScreenKey: Record<string, string> = {
  overview: 'loanOverview',
  structure: 'loanStructure',
  structurePrint: 'loanStructure',
  application: 'loanApplication',
  submit: 'loanSubmission',
}

export const resolveContactInfoScreenKey = (pathname: string, menu: string | null = null): string | null => {
  const fromFloater = resolveFloaterPageKey(pathname, menu)
  if (fromFloater) return fromFloater

  let bestKey: string | null = null
  let bestScore = -1

  // Honor floater aliases for pages that share prefixes with quick links.
  Object.keys(pageUrlAliases).forEach((key) => {
    ;(pageUrlAliases[key] || []).forEach((prefix) => {
      if (!pathname.startsWith(prefix)) return
      if (prefix.length > bestScore) {
        bestScore = prefix.length
        bestKey = key
      }
    })
  })

  return bestKey
}

export const isPullThroughRatioVisibleOnScreen = (
  globalSettingV2: { pullThroughRatioScreens?: Record<string, boolean> } | null | undefined,
  screenKey: string,
): boolean => {
  const screens = {
    ...defaultPullThroughRatioScreens(),
    ...(globalSettingV2?.pullThroughRatioScreens || {}),
  }
  return !!screens[screenKey]
}
